import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const PaymentOverviewDialog = ({ open, onClose, treatment }) => {
  const { t } = useTranslation();

  if (!treatment) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{t("dental.paymentOverview")}</DialogTitle>
      <DialogContent dividers>
        <Box mb={2}>
          <Typography variant="subtitle1">
            <strong>{t("dental.patient")}:</strong> {treatment.patient_name}
          </Typography>
          <Typography variant="subtitle1">
            <strong>{t("dental.dentist")}:</strong> {treatment.dentist_name}
          </Typography>
          <Typography variant="subtitle1">
            <strong>{t("dental.treatmentDate")}:</strong>{" "}
            {treatment.treatment_date}
          </Typography>
        </Box>
        <TableContainer component={Paper} sx={{ mb: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{t("dental.paymentDate")}</TableCell>
                <TableCell>{t("dental.amount")}</TableCell>
                <TableCell>{t("dental.status")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody sx={{ bgcolor: "#ccfcfc" }}>
              {treatment.payments.map((payment) => (
                <TableRow key={payment.id}>
                  <TableCell>
                    {new Date(payment.date).toLocaleDateString()}
                  </TableCell>
                  <TableCell>{payment.amount}</TableCell>
                  <TableCell>
                    {payment.is_deleted
                      ? t("dental.deleted")
                      : t("dental.completed")}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Box>
          <Typography variant="h6">
            {t("dental.totalPaid")}: {treatment.total_paid}
          </Typography>
          <Typography variant="h6">
            {t("dental.balanceDue")}: {treatment.balance_due}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          {t("dental.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentOverviewDialog;
